import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import LoginPage from "./pages/LoginPage.vue";
import RegisterLastStepPage from "./pages/RegisterLastStepPage.vue";
import { defaultLocale, fallbackLocale } from "@ocm/services/services.i18n";
import de from "./i18n/de.json";
import en from "./i18n/en.json";
import { store } from "@/state/store";
import { initStore } from "@/state/initStore";

import { setWebpackPublicPath } from "../../shared/js/webpack-utils";
setWebpackPublicPath();

const rootContainerID = "mf-login";
initStore(rootContainerID);

const i18n = createI18n({
	locale: defaultLocale,
	fallbackLocale,
	messages: { de, en },
	legacy: false,
});
const $t = i18n.global.t;

function renderLoginForm() {
	const app = createApp(renderPage());

	app.use(i18n);
	app.mount(`#${rootContainerID}`);
}

function renderPage() {
	if (store.isLastStepPage) return RegisterLastStepPage;
	return LoginPage;
}

// wait for DOM Loaded
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", renderLoginForm);
} else {
	renderLoginForm();
}

export { $t };

// on legacy landingpages a separate benefit-bar was used
// this benefit-bar is not used anymore
// const benefitItemsWrapper = document.querySelectorAll(".benefit-items-wrapper");
// benefitItemsWrapper.forEach((wrapper) => {
// 	wrapper.remove();
// });
